import { Link } from "react-router";
import { Aviso, Chip } from "../ui";
import { mensagemDoConsole } from "../../nucleo/console";
import { CHIP_DA_FAIXA, quedaDeFaixa, useAlertasDeSaude, type AlertaDeSaude } from "../../nucleo/sucesso";

function quando(iso: string): string {
  const data = new Date(iso);
  return Number.isNaN(data.getTime())
    ? "—"
    : new Intl.DateTimeFormat("pt-BR", { dateStyle: "short", timeStyle: "short" }).format(data);
}

/** Quem caiu de faixa, do mais recente ao mais antigo, e quem foi avisado. */
export function ListaDeAlertas({
  alertas,
  semLink = false,
}: {
  alertas: readonly AlertaDeSaude[];
  semLink?: boolean;
}) {
  return (
    <ul className="lista-de-itens" data-testid="lista-de-alertas">
      {alertas.map((alerta) => (
        <li key={alerta.id} data-testid={`alerta-${alerta.organizacao.nome}`}>
          <Chip estado={CHIP_DA_FAIXA[alerta.para_faixa]}>{quedaDeFaixa(alerta)}</Chip>{" "}
          {semLink ? (
            <b>{alerta.organizacao.nome}</b>
          ) : (
            <Link to={`/admin/sucesso/${alerta.organizacao.id}`}>{alerta.organizacao.nome}</Link>
          )}{" "}
          <span className="celula-secundaria">
            de {alerta.score_anterior} para {alerta.score} pontos · {quando(alerta.gerado_em)} ·{" "}
            {alerta.responsavel ? `avisado: ${alerta.responsavel.nome}` : "sem responsável de CS para avisar"}
          </span>
        </li>
      ))}
    </ul>
  );
}

export function PainelDeAlertas() {
  const alertas = useAlertasDeSaude();
  return (
    <div data-testid="painel-de-alertas">
      <p className="lead mb-3">
        Cada vez que um cliente muda para uma faixa pior, o responsável de CS recebe um e-mail e a
        queda aparece aqui.
      </p>
      {alertas.isPending ? <p role="status">Carregando alertas…</p> : null}
      {alertas.isError ? <Aviso tom="erro">{mensagemDoConsole(alertas.error)}</Aviso> : null}
      {alertas.data && alertas.data.length === 0 ? <Aviso tom="marca">Nenhuma queda de faixa registrada.</Aviso> : null}
      {alertas.data && alertas.data.length > 0 ? <ListaDeAlertas alertas={alertas.data} /> : null}
    </div>
  );
}
